// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

import BullTurnNumCom from "./bull_turn_num_com";

const {ccclass, property} = cc._decorator;

@ccclass
export default class BullTurnNumAniCom extends cc.Component {



    private nodes : cc.Node[] = [];

    onLoad(){


        this.nodes = this.node.children;
    }

  

    onTriggered(nodeIndex : number) {

        console.log(" onTriggered " , nodeIndex);


        let com = this.node.children[nodeIndex].getComponent(BullTurnNumCom);
    
        com.onTriggered();
        
    }
}
